import React from 'react'
import ReactDOM from 'react-dom'
import './styles/index.scss'
//import App from './App'
import IntroBox from './components/IntroBox'
import Dynamism from './components/Dynamism'
import reactToWebComponent from 'react-to-webcomponent'
import BottomSection from './components/BottomSection'
//import reportWebVitals from './reportWebVitals'

// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById('root')
// )
const DynamismIntroBox = () => <IntroBox />
const DynamismCharts = () => <Dynamism />
const DynamismBoxes = () => <BottomSection />

customElements.define(
  'react-dynamism-intro-box',
  reactToWebComponent(DynamismIntroBox, React, ReactDOM)
)

customElements.define(
  'react-dynamism-charts',
  reactToWebComponent(DynamismCharts, React, ReactDOM)
)

customElements.define(
  'react-dynamism-boxes',
  reactToWebComponent(DynamismBoxes, React, ReactDOM)
)
